class Tag {
  contructor() {
    this.location = 'head';
  }
}

export { Tag };
